import { render } from "./RiskStabilityIndicatorsChart.vue?vue&type=template&id=27e5fa00&ts=true"
import script from "./RiskStabilityIndicatorsChart.vue?vue&type=script&lang=ts"
export * from "./RiskStabilityIndicatorsChart.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__